import { Box, CircularProgress } from "@mui/material";
import './index.css';

export const Loader = (props) => {

    return (
        <Box className={`${props.className || "loader_cls"} loader_cls`} >
            <CircularProgress color="inherit" />
        </Box>
    )
}
